module.exports = __webpack_public_path__ + "img/reference-scenes-and-costumes.998d62ce.jpg";